export const GreenSquare = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect x="4.5" y="4.5" width="7" height="7" rx="2" fill="#20AC93" />
		</svg>
	);
};
